import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import type { MailboxInfo } from "owa-client-types";
import { getAccountScopeUserSettings } from "owa-session-store";

export default function getCompanyName(mailboxInfo?: MailboxInfo): string | undefined {
    return !!mailboxInfo
        ? getAccountScopeUserSettings(mailboxInfo)?.SessionSettings?.CompanyName
        : getUserConfiguration()?.SessionSettings?.CompanyName;
}
